export type IconProps = {
  size?: number;
  className?: string;
};

export * from './BranchInformationIcon';
export * from './BranchManagementIcon';
export * from './CashManagementIcon';
export * from './ForexManagementIcon';
export * from './HeadsetIcon';
export * from './StockManagementIcon';
export * from './DeveloperOptionsIcon';
